import { ActivityArt } from "@/components/art/Illustrations";
import { useCourtyard } from "@/context/CourtyardContext";
import { Reveal, SectionHead } from "@/components/invite/Reveal";

const BG = ["bg-[var(--cream)]", "bg-yellow-print", "bg-[var(--cream)]", "bg-yellow-print"];

export default function Activities() {
  const { event: ev } = useCourtyard();
  const items = Array.isArray(ev.activities) ? ev.activities : [];
  if (!items.length) return null;
  return (
    <section className="bg-navy-print on-dark relative py-20 lg:py-28" aria-labelledby="glimpse-title">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <SectionHead eyebrow="Shaam ka scene" title="A glimpse of the evening" id="glimpse-title" light>
          Loosely planned, fully intended. The evening may wander a little.
        </SectionHead>
        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((a, i) => (
            <Reveal as="li" key={a.id || i} delay={i * 0.07}>
              <article className={`pop flex h-full flex-col overflow-hidden text-[var(--navy)] transition-transform duration-200 hover:-translate-y-1 ${BG[i % 4]}`} data-testid={`activity-card-${i}`}>
                <div className="bg-pink-print relative flex aspect-[16/10] items-center justify-center border-b-[2.5px] border-[var(--navy)] px-6">
                  <div className="dots-cream absolute inset-0" aria-hidden="true" />
                  <div className="relative w-[78%] rounded-[16px] border-[2.5px] border-[var(--navy)] bg-[var(--cream)] p-2"><ActivityArt icon={a.icon} /></div>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="font-poster text-3xl text-[var(--pink)]">0{i + 1}</span>
                    {a.time && <span className="rounded-full border-2 border-[var(--navy)] bg-[var(--cream)] px-3 py-0.5 text-xs font-extrabold">{a.time}</span>}
                  </div>
                  <h3 className="font-poster mt-1 text-2xl leading-tight">{a.title}</h3>
                  <p className="mt-2 text-[0.98rem] leading-relaxed">{a.description}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
